/* NecksLevel — native homepage product carousel.
   Replaces Replo's carousel runtime: scroll-snap track + arrows + dots (phone only). */
(function () {
  function init(root) {
    var track = root.querySelector('[data-nl-track]');
    if (!track) return;
    var prev = root.querySelector('[data-nl-prev]');
    var next = root.querySelector('[data-nl-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-nl-dot]'));
    var slides = root.querySelectorAll('.nl-hcar__slide');

    function step() {
      if (!slides.length) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function current() {
      return Math.round(track.scrollLeft / step());
    }

    function go(i) {
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }

    // Only show an arrow when there is somewhere for it to go (Scott, 2026-10-07).
    function updateArrows(i) {
      if (prev) prev.classList.toggle('is-off', i <= 0);
      if (next) next.classList.toggle('is-off', i >= slides.length - 1);
    }
    updateArrows(current());

    // The arrows used to be placed level with the product title on every size (Scott, 2026-10-07, so they
    // would not cover the artwork). On phones that put them straight through the product name, so from
    // 2026-10-31 phones drop them onto the dot row instead, which is a plain CSS rule. Clearing the inline
    // top is what lets that rule through: an inline style beats a stylesheet, so leaving a stale value here
    // would silently win. Above the phone breakpoint the title maths is unchanged.
    var viewport = track.parentElement;
    function placeArrows() {
      var title = track.querySelector('.nl-hcar__title');
      if (!title || !prev || !next) return;
      if (window.matchMedia && window.matchMedia('(max-width: 640px)').matches) {
        prev.style.top = '';
        next.style.top = '';
        return;
      }
      var vb = viewport.getBoundingClientRect();
      var tb = title.getBoundingClientRect();
      var h = next.offsetHeight || prev.offsetHeight || 40;  // one of them may be hidden
      var top = Math.round(tb.top - vb.top + tb.height / 2 - h / 2);
      prev.style.top = top + 'px';
      next.style.top = top + 'px';
    }
    placeArrows();
    window.addEventListener('resize', placeArrows);
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', placeArrows);
    });

    if (prev) prev.addEventListener('click', function () { go(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(slides.length - 1, current() + 1)); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-nl-dot'), 10) || 0);
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var i = current();
        dots.forEach(function (dot, j) { dot.classList.toggle('is-active', i === j); });
        updateArrows(i);
        ticking = false;
      });
    }, { passive: true });
  }

  function boot() {
    document.querySelectorAll('.nl-hcar').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
